import React from 'react';
import { WagmiConfig, configureChains, createConfig, mainnet } from 'wagmi';
import { InjectedConnector, watchAccount } from '@wagmi/core';
import { publicProvider } from 'wagmi/providers/public';
import { createModal } from '@rabby-wallet/rabbykit';
import { arbitrum, bsc, optimism, polygon } from 'viem/chains';

// import { openEmailLoginModal } from '@/utils/Login/EmailLoginModal';
import { getIsMobile } from '@/hooks';
import iDebankLogo from 'assets/debank-app-login.svg';
import { loginGa } from '@/utils';

const { chains, publicClient, webSocketPublicClient } = configureChains(
  [mainnet, arbitrum, bsc, optimism, polygon],
  [
    //todo: add Infura or Alchemy provider or jsonRpcProvider
    // alchemyProvider({ apiKey: 'yourAlchemyApiKey' }),
    // infuraProvider({ apiKey: 'yourInfuraApiKey' }),
    publicProvider(),
  ],
);

export const defaultInjectedConnector = new InjectedConnector({
  options: { getProvider: () => window.ethereum },
});

const config = createConfig({
  autoConnect: true,
  publicClient,
  webSocketPublicClient,
  connectors: [defaultInjectedConnector],
});

export const rabbyKit = createModal({
  chains,
  wagmi: config,
  projectId: 'ea1d89f783eee63c74c2b73a248c46a8',
  appName: 'DeBank',
  appLogo: iDebankLogo,
  showWalletConnect: false,
});

// 原来是标记 rabbykit 内有没有email 登陆的
// 去掉 email 登陆的话，只做 login / connect 的标记
export let withEmailLogin = false;

export const addEmailLogin = () => {
  withEmailLogin = true;
};

watchAccount(e => {
  if (e.isConnecting && !getIsMobile()) {
    if (withEmailLogin) {
      loginGa({ hasConnected: false, action: 'Login_Connecting' });
    }
  }
});

export const removeEmailLogin = () => {
  withEmailLogin = false;
};

export const RabbykitProvider = ({ children }: React.PropsWithChildren<{}>) => {
  return <WagmiConfig config={config}>{children}</WagmiConfig>;
};
